<template>
    <div>
        <nav class="navbar navbar-expand-md fixed-top navbar-light nav-main">
            <div class="container">
                <router-link class="navbar-brand" to="/home" tag="a">
                    <img src="/static/images/logos/alphabet.svg">
                </router-link>
                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02"
                aria-expanded="false" aria-label="Toggle navigation">
                    <span class="menu-bar"></span>
                    <span class="menu-bar"></span>
                    <span class="menu-bar"></span>
                </button>
                <div class="collapse navbar-collapse">
                    <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
                    </ul>
                    <div class="my-2 my-lg-0 navbar-address">
                        {{ info.phone }}<br>
                        <div>{{ info.address.street }}<br>{{ info.address.city }}</div>
                    </div>
                </div>

            </div>
        </nav>
        <nav class="navbar navbar-expand-md fixed-top navbar-light sub-navbar-links">
            <div class="container">
                <nav-links :items="items" :ulClass="'navbar-nav mr-auto mt-2 mt-lg-0'"></nav-links>
                
            </div>
        </nav>
        <div class="navbar-mobile">
            <div class="sidemenu-header">
                <span>Menu</span>
            </div>
            <div class="sidemenu-content">
                <nav-links :items="items" :ulClass="'navbar-nav mr-auto mt-2 mt-lg-0'"></nav-links>
            </div>
            <div class="sidemenu-footer">
                <img src="/static/images/logos/alphabet-branca.svg" alt="">
                
            </div>
            <button class="navbar-toggler">&times;</button>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['info', 'items'],
        mounted() {
            
            $('.navbar-toggler').click(() => {
                $('nav').css('display','none');
                $('body').css('overflow-y', 'hidden');
                $('header, section, footer, aside').css('transform','translateX(-80%)');
                $('.navbar-mobile').css('display', 'block');
            });

            $('.navbar-mobile button').click(() => {
                $('nav').css('display','');
                $('body').css('overflow-y', '');
                $('header, section, footer, aside').css('transform','');
                $('.navbar-mobile').css('display', '');
            });
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Navbar.vue